// extracted by mini-css-extract-plugin
module.exports = {"container":"_2hlPH","triangleBorder":"_1zqvt","defaultColor":"M8oDP","triangleBackground":"UU24v"};